import { render, staticRenderFns } from "./EmployeeAllowanceView.vue?vue&type=template&id=287813c9"
import script from "./EmployeeAllowanceView.vue?vue&type=script&lang=js"
export * from "./EmployeeAllowanceView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports